import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAllStocks, getStockQuote } from "../services/stockApi";
import Navigation from "../components/Navigation";
// import { fetchCurrencyRates } from "../services/currencyApi"; // Dodaj jeśli masz currencyApi.js

const MarketScreenLoggedIn = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState("explore");
  const [activeTab, setActiveTab] = useState("stocks");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [cryptos, setCryptos] = useState([]);
  const [etfs, setEtfs] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  // Przykładowe symbole jak w mobile app
  const STOCK_SYMBOLS = [
    "AAPL",
    "MSFT",
    "GOOGL",
    "AMZN",
    "NVDA",
    "META",
    "TSLA",
    "BRK-A",
    "TSM",
    "LLY",
    "V",
    "JPM",
    "XOM",
    "AVGO",
    "WMT",
    "UNH",
    "MA",
    "PG",
    "JNJ",
    "ORCL",
  ];
  const CRYPTO_SYMBOLS = [
    "BTC",
    "ETH",
    "BNB",
    "SOL",
    "XRP",
    "ADA",
    "DOGE",
    "DOT",
    "LINK",
  ];
  const ETF_SYMBOLS = ["SPY", "QQQ", "VTI", "EFA", "IEMG"];
  const CURRENCY_SYMBOLS = ["USD", "EUR", "GBP", "JPY", "CHF", "DKK"];

  useEffect(() => {
    setLoading(true);
    setError(null);
    const fetchData = async () => {
      try {
        if (activeTab === "stocks") {
          const all = await getAllStocks();
          // Filtrowanie i kolejność jak w mobile
          setStocks(
            all
              .filter((s) => STOCK_SYMBOLS.includes(s.symbol))
              .slice(0, STOCK_SYMBOLS.length)
          );
        } else if (activeTab === "crypto") {
          const all = await getAllStocks();
          setCryptos(
            all
              .filter((s) => CRYPTO_SYMBOLS.includes(s.symbol))
              .slice(0, CRYPTO_SYMBOLS.length)
          );
        } else if (activeTab === "etfs") {
          const all = await getAllStocks();
          setEtfs(
            all
              .filter((s) => ETF_SYMBOLS.includes(s.symbol))
              .slice(0, ETF_SYMBOLS.length)
          );
        } else if (activeTab === "currencies") {
          // Jeśli masz fetchCurrencyRates, odkomentuj poniżej:
          // const rates = await fetchCurrencyRates();
          // setCurrencies(Object.entries(rates).filter(([symbol]) => CURRENCY_SYMBOLS.includes(symbol)).map(([symbol, price]) => ({ symbol, price })));
          // Tymczasowo mock:
          setCurrencies([
            { symbol: "USD", name: "US Dollar", price: 1.0 },
            { symbol: "EUR", name: "Euro", price: 0.92 },
            { symbol: "GBP", name: "British Pound", price: 0.78 },
            { symbol: "JPY", name: "Japanese Yen", price: 145.2 },
            { symbol: "CHF", name: "Swiss Franc", price: 0.98 },
          ]);
        }
      } catch (e) {
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [activeTab]);

  let filteredData = [];
  if (activeTab === "stocks") filteredData = stocks;
  else if (activeTab === "crypto") filteredData = cryptos;
  else if (activeTab === "etfs") filteredData = etfs;
  else if (activeTab === "currencies") filteredData = currencies;

  filteredData = filteredData.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.symbol?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="screen">
      <Navigation />
      <div className="screen-header" style={{ marginTop: 56 }}>
        <h1 className="screen-title">Market Overview</h1>
        <p className="screen-subtitle">
          Track stocks, cryptos, ETFs, currencies, and your portfolio in
          real-time
        </p>
      </div>
      {/* Page Navigation */}
      <div className="card" style={{ marginBottom: 24 }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 24 }}>
          <button
            onClick={() => setCurrentPage("explore")}
            className={`btn ${currentPage === "explore" ? "" : "btn-outline"}`}
          >
            Explore
          </button>
          <button
            onClick={() => setCurrentPage("watchlists")}
            className={`btn ${
              currentPage === "watchlists" ? "" : "btn-outline"
            }`}
          >
            Watchlists
          </button>
          <button
            onClick={() => setCurrentPage("owned")}
            className={`btn ${currentPage === "owned" ? "" : "btn-outline"}`}
          >
            Your Stocks
          </button>
        </div>
      </div>
      {/* Explore Section */}
      {currentPage === "explore" && (
        <>
          {/* Tab Navigation */}
          <div className="card">
            <div
              className="flex gap-2"
              style={{ marginBottom: "20px", flexWrap: "wrap" }}
            >
              <button
                onClick={() => setActiveTab("stocks")}
                className={`btn ${activeTab === "stocks" ? "" : "btn-outline"}`}
              >
                📈 Stocks
              </button>
              <button
                onClick={() => setActiveTab("crypto")}
                className={`btn ${activeTab === "crypto" ? "" : "btn-outline"}`}
              >
                🪙 Cryptos
              </button>
              <button
                onClick={() => setActiveTab("etfs")}
                className={`btn ${activeTab === "etfs" ? "" : "btn-outline"}`}
              >
                📊 ETFs
              </button>
              <button
                onClick={() => setActiveTab("currencies")}
                className={`btn ${
                  activeTab === "currencies" ? "" : "btn-outline"
                }`}
              >
                💱 Currencies
              </button>
            </div>
            {/* Search Bar */}
            <div className="form-group">
              <input
                type="text"
                className="form-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            {/* Market Data */}
            {loading ? (
              <div
                style={{
                  color: "#94A3B8",
                  padding: "40px",
                  textAlign: "center",
                }}
              >
                Loading...
              </div>
            ) : error ? (
              <div
                style={{ color: "red", padding: "40px", textAlign: "center" }}
              >
                {error}
              </div>
            ) : (
              <div className="grid-2">
                {filteredData.length === 0 && (
                  <div
                    className="text-center"
                    style={{ color: "#94A3B8", padding: "40px" }}
                  >
                    No results found for "{searchTerm}"
                  </div>
                )}
                {filteredData.map((item, index) => (
                  <div
                    key={index}
                    className="stock-item"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="stock-header">
                      <div>
                        <div className="stock-name">
                          {item.name || item.symbol}
                        </div>
                        <div className="stock-symbol">{item.symbol}</div>
                      </div>
                      <div className="text-right">
                        {item.price && (
                          <div className="stock-price">
                            {typeof item.price === "number"
                              ? `$${item.price}`
                              : item.price}
                          </div>
                        )}
                        {item.value && (
                          <div className="stock-price">{item.value}</div>
                        )}
                        {item.shares && (
                          <div className="stock-shares">
                            {item.shares} shares
                          </div>
                        )}
                        {item.changePercent && (
                          <div
                            className={`stock-change ${
                              String(item.changePercent).startsWith("+")
                                ? "positive"
                                : "negative"
                            }`}
                          >
                            {item.change} ({item.changePercent})
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
      {/* Watchlists Section */}
      {currentPage === "watchlists" && (
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Your Watchlists</h3>
          </div>
          {/* ...watchlists mock or API... */}
        </div>
      )}
      {/* Your Stocks Section */}
      {currentPage === "owned" && (
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Your Stocks</h3>
          </div>
          {/* ...owned stocks mock or API... */}
        </div>
      )}
      {/* Market Stats */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Market Statistics</h3>
        </div>
        <div className="grid-3">
          <div className="portfolio-card">
            <div className="portfolio-value">$2.1T</div>
            <div className="portfolio-label">Total Market Cap</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">$45.2B</div>
            <div className="portfolio-label">24h Volume</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">+2.34%</div>
            <div className="portfolio-label">Market Change</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketScreenLoggedIn;
